import { defineMenu } from '@/utils/menu'

const menuPrincipal = defineMenu([])

export default menuPrincipal
